"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccessControlEventType = void 0;
var AccessControlEventType;
(function (AccessControlEventType) {
    AccessControlEventType["RoleGranted"] = "RoleGranted";
    AccessControlEventType["RoleRevoked"] = "RoleRevoked";
    AccessControlEventType["RoleAdminChanged"] = "RoleAdminChanged";
    AccessControlEventType["DefaultAdminTransferScheduled"] = "DefaultAdminTransferScheduled";
    AccessControlEventType["DefaultAdminTransferCanceled"] = "DefaultAdminTransferCanceled";
    AccessControlEventType["DefaultAdminDelayChangeScheduled"] = "DefaultAdminDelayChangeScheduled";
    AccessControlEventType["DefaultAdminDelayChangeCanceled"] = "DefaultAdminDelayChangeCanceled";
    AccessControlEventType["OwnershipTransferred"] = "OwnershipTransferred";
    AccessControlEventType["OwnershipTransferStarted"] = "OwnershipTransferStarted";
})(AccessControlEventType || (exports.AccessControlEventType = AccessControlEventType = {}));
//# sourceMappingURL=access-control.js.map